import React from "react";
export default function NotFoundPage() {
  return (
    <div
      style={{
        height: "300px",
        display: "flex",

        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div className="head2_b">죄송합니다</div>
      <div className="body2 gray800">
        찾을 수 없는 페이지를 요청하셨습니다.
        <br />
        요청하신 페이지의 주소가 변경, 삭제되어
        <br />
        찾을 수 없습니다.
      </div>
    </div>
  );
}
